/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';
import { useSelector } from 'react-redux';

// Navbar
import Navbar from 'examples/Navbars/NavBar';

function DashboardMenu() {
  const mod = 'dashboard_menu';
  const { t, i18n } = useTranslation();
  const app = useSelector((state) => state[APP_STATE]);
  const [grid1, setGrid1] = useState([]);
  const [grid2, setGrid2] = useState([]);
  const [grid3, setGrid3] = useState([]);
  const [grid4, setGrid4] = useState([]);

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setGrid1(result.grid1);
        setGrid2(result.grid2);
        setGrid3(result.grid3);
        setGrid4(result.grid4);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (item) => {
    return (
      <MDBox key={item.id}>
        <MDButton color='dark' href={`/${item.code}`} variant='text' fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
              textTransform: 'none',
            }}
          >
            <Icon>navigate_next</Icon> {item.name}{' '}
            {item.shortcode === '' ? null : `(${item.shortcode})`}
          </Box>
        </MDButton>
      </MDBox>
    );
  };

  const renderButton = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {grid1.map((row) => (
            <Card key={row.id} sx={{ mb: 2 }}>
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant='h6'>
                          <Icon sx={{ pt: 0.25 }}>{row.icon}</Icon> {row.name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{row.sub.map((item) => setBtnBadge(item))} </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ))}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {grid2.map((row) => (
            <Card key={row.id} sx={{ mb: 2 }}>
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant='h6'>
                          <Icon sx={{ pt: 0.25 }}>{row.icon}</Icon> {row.name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{row.sub.map((item) => setBtnBadge(item))} </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ))}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {grid3.map((row) => (
            <Card key={row.id} sx={{ mb: 2 }}>
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant='h6'>
                          <Icon sx={{ pt: 0.25 }}>{row.icon}</Icon> {row.name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{row.sub.map((item) => setBtnBadge(item))} </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ))}
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          {grid4.map((row) => (
            <Card key={row.id} sx={{ mb: 2 }}>
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <MDTypography variant='h6'>
                          <Icon sx={{ pt: 0.25 }}>{row.icon}</Icon> {row.name}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{row.sub.map((item) => setBtnBadge(item))} </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ))}
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, []);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.dashboard`), t(`menu.dashboard_menu`)]} />
      <MDBox py={3}>{renderButton()}</MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DashboardMenu;
